import React from 'react';
import Header from '../sections/Header';
import Banner from '../sections/Banner';
import Footer from '../sections/Footer';
import SectionHeader from '../composites/SectionHeader';
import FeatureCard from '../composites/FeatureCard';
import Breadcrumbs from '../sections/Breadcrumbs';

const Initiatives: React.FC = () => {
  const initiatives = [
    {
      title: 'AI Literacy Uplift & Alignment',
      description: 'Building AI fluency and confidence across the organization through structured learning pathways and hands-on experience.',
      image: '/logos/aiLiteracy.svg',
      status: 'Active',
      link: { href: '/initiative-one/ai-literacy-uplift-and-alignment', label: 'Learn More', variant: 'secondary' as const, size: 'sm' as const },
    },
    {
      title: 'Build Platform',
      description: 'Developing our flagship AI platform for experimentation, collaboration, and innovation across all AI capabilities.',
      image: '/logos/dev-platform.svg',
      status: 'Active',
      link: { href: '/initiative-two/build-platform', label: 'Learn More', variant: 'secondary' as const, size: 'sm' as const },
    },
    {
      title: 'Companion Incubator',
      description: 'A practical framework to propose, test, and scale new AI tools and capabilities within our organization.',
      image: '/logos/ideasIncubator.svg',
      status: 'Active',
      link: { href: '/initiative-three/companion-incubator', label: 'Learn More', variant: 'secondary' as const, size: 'sm' as const },
    },
    {
      title: 'Ecosystem Watch',
      description: 'Tracking AI trends, vendor updates, and emerging opportunities to stay ahead of the curve.',
      image: '/logos/Ecosystem.svg',
      status: 'Active',
      link: { href: '/initiatives/ecosystem', label: 'Learn More', variant: 'secondary' as const, size: 'sm' as const },
    },
  ];

  return (
    <>
      <Header />
      <Banner
        breadcrumbs={<Breadcrumbs items={[{ label: 'Home', href: '/' }, { label: 'Initiatives' }]} />}
        title="Our AI Initiatives"
        subtitle="Discover the key initiatives driving AI innovation and capability building across our organization."
        colorVariant="gradient"
        imageVariant="withImage"
        paddingVariant="default"
        showCTAs={true}
        showDefaultGraphic={true}
      />

      <div className="bg-white w-full">
        <div className="max-w-7xl mx-auto px-4 py-12">
          <SectionHeader
            heading="Current Initiatives"
            description="Our four core initiatives work together to build comprehensive AI capabilities and drive innovation across all aspects of our business."
          />

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mt-8">
            {initiatives.map((initiative, idx) => (
              <FeatureCard
                key={initiative.title}
                customImage={initiative.image}
                title={initiative.title}
                description={initiative.description}
                link={initiative.link}
                className="h-full"
                animate={true}
                delay={idx * 0.1}
              />
            ))}
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default Initiatives; 